import http from './http';

class DashboardService {
    getDashboardData(queryParams) {
        return http.get('/dashboard', { params: queryParams });
    }
}

export default new DashboardService(); 
